import { Group } from '@mantine/core';
import type { DataQualitySuggestion } from '@repo/api-codegen';
import { Text } from '@repo/foundations';
import { sentenceCase } from '../../../utils/stringUtils';
import { DATA_QUALITY_MAX_SCORE } from '../constants';
import { DataQualityProgressIcon } from '../DataQualityProgressIcon';
import { renderScore } from './scoreRenderer';

export interface DataQualityDetailsGroupProps {
	score: number;
	scoreType: 'points' | 'percentage';
	dataQualityKey: DataQualitySuggestion['data_quality_top_key'];
}

export function DataQualityDetailsGroup({
	score,
	scoreType,
	dataQualityKey,
}: DataQualityDetailsGroupProps) {
	return (
		<Group position="apart" spacing={0}>
			<Group spacing="xs">
				<DataQualityProgressIcon
					score={(score / DATA_QUALITY_MAX_SCORE[dataQualityKey]) * 100}
				/>
				<Text size="sm" fw={500}>
					{sentenceCase(String(dataQualityKey))}
				</Text>
			</Group>
			<Text size="sm" color="text/secondary/default">
				{renderScore(scoreType, score, DATA_QUALITY_MAX_SCORE[dataQualityKey])}
			</Text>
		</Group>
	);
}
